import { http } from "@/api/index";

const Login = function(login)
{
	return http.post("/Account/Login", login);
};

const GetAcessToken = function()
{
	return http.post("/Account/RefreshToken");
};

const Logout = function()
{
	return http.delete("/Account/Logout");
};
export default {
	Login, GetAcessToken, Logout,
};
